import React, { useState, useEffect } from "react";
import { doc, updateDoc, getDoc, deleteDoc } from "firebase/firestore";
import { db, auth } from "../api/firebase";
import { Button } from "@mui/material";
import { TextField } from "@mui/material";

import { useDocumentData } from "react-firebase-hooks/firestore";
// redux - use
import { useNotification } from "../redux/useNotification";

const DeleteQuestionType = ({ setOpen, target }) => {
  // redux - Notification
  const { displayNotification } = useNotification();

  // プロフィール変更値格納コンテナ
  const [data, setData] = useState({
    reason: "",
    message: "",
    error: null,
    loading: false,
  });
  const { reason, message, error, loading } = data;

  // 自分の情報取得
  const [userInfo, setUserInfo] = useState("");
  useEffect(() => {
    const getUser = async () => {
      getDoc(doc(db, "users", auth.currentUser.uid)).then((doc) => {
        setUserInfo({ id: doc.id, ...doc.data() });
      });
    };
    getUser();
  }, []);
  const [questionType] = useDocumentData(doc(db, "questionType", target));

  // プロフィール変更処理
  const handleSubmit = async (e) => {
    e.preventDefault();
    setData({ ...data, error: null, loading: true });
    try {
      // 空欄or変更がない時
      // console.log("data[e.target.name] =>", data[e.target.name]);
      // if (!data[e.target.name]) {
      //   setData({ ...data, message: "空欄なようです" });
      //   return false;
      // }

      // 変更処理
      await deleteDoc(doc(db, "questionType", target));
      displayNotification({
        message: "お問い合わせ種類を削除しました。",
        type: "success",
      });
      setData({
        [e.target.name]: "",
        error: null,
        loading: false,
      });

      // window.location.reload();
      setOpen(false);
    } catch (err) {
      setData({ ...data, error: err.message, loading: false });
      console.log("err =>", err);
    }
  };
  // const handeDeleteTarget = (e) => {
  //   console.log(e.target.innerText);
  // };

  return (
    <>
      <form onSubmit={(e) => e.preventDefault()}>
        <div className="mb-3">お問い合わせ種類の削除</div>
        <div>以下のお問い合わせ種類を削除します。</div>
        <div className="border rounded-md p-1">{questionType?.reason}</div>
        {/* <TextField
          id="outlined-required"
          name="reason"
          label="お問い合わせ種類"
          defaultValue=""
          size="small"
          placeholder={questionType?.reason}
          className=" w-full "
          onChange={handleChange}
          required
          disabled={loading}
          // inputProps={{maxLength:18}}
        /> */}

        <Button
          className="btn"
          name="reason"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "送信しています..." : "削除"}
        </Button>
        {message ? <div className=" text-red-500">{message}</div> : ""}
        {error ? error : ""}
      </form>
    </>
  );
};

export default DeleteQuestionType;
